import { render, staticRenderFns } from "./OrderUploadTaxSituationProof.vue?vue&type=template&id=962b13fe&scoped=true&"
import script from "./OrderUploadTaxSituationProof.vue?vue&type=script&lang=js&"
export * from "./OrderUploadTaxSituationProof.vue?vue&type=script&lang=js&"
import style0 from "./OrderUploadTaxSituationProof.vue?vue&type=style&index=0&id=962b13fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "962b13fe",
  null
  
)

export default component.exports